<template>
  <div class="appointment_data">
    <van-sticky>
      <van-nav-bar title="预约上门时间" left-arrow @click-left="goback()" />
    </van-sticky>

    <div class="data_title" style="background: #f4f3f8">填写上门信息</div>

    <van-form
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <!-- 预约时间 -->
      <div class="data_time">
        <div class="time_list">
          <div>预约类型</div>
          <div class="list_input" @click="showType = true">
            <input
              :value="submitData.type_name"
              readonly
              placeholder="请选择"
            />
            <van-icon name="arrow-down" size="15" color="#999" />
          </div>
        </div>
        <van-action-sheet
          v-model="showType"
          :actions="actions"
          cancel-text="取消"
          close-on-click-action
          @select="onSelect"
        />

        <div class="time_list">
          <div>上门日期</div>
          <div class="list_input" @click="showData = true">
            <van-icon name="calendar-o" size="15" color="#999" />
            <input
              :value="submitData.onSiteDate"
              readonly
              placeholder="选择日期"
            />
          </div>
        </div>

        <van-calendar
          type="single"
          v-model="showData"
          @confirm="onConfirmData"
        />

        <div class="time_list">
          <div>上门时间</div>
          <div class="list_input" @click="showTime = true">
            <van-icon name="clock-o" size="15" color="#999" />
            <input
              :value="submitData.onSiteTime"
              readonly
              class="p-r20"
              placeholder="选择时间点"
            />
          </div>
        </div>

        <van-action-sheet v-model="showTime">
          <van-datetime-picker
            type="time"
            title="选择时间"
            :min-hour="9"
            :max-hour="18"
            @confirm="onConfirmTime"
            @cancel="showTime = false"
          />
        </van-action-sheet>
      </div>

      <div class="data_title">备注</div>

      <van-field
        v-model="submitData.remark"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入更多订单备注信息(选填)"
        show-word-limit
      />

      <van-button
        class="m-t50"
        block
        color="#0CADFC"
        type="info"
        native-type="submit"
        >确认提交</van-button
      >
    </van-form>
  </div>
</template>

<script>
import {
  Button,
  NavBar,
  Sticky,
  Form,
  Field,
  Icon,
  Calendar,
  DatetimePicker,
  Cell,
  ActionSheet,
  Popup,
} from "vant";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Form.name]: Form,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Calendar.name]: Calendar,
    [DatetimePicker.name]: DatetimePicker,
    [Cell.name]: Cell,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
  },
  data() {
    return {
      submitData: {
        order_info_id: 0,
        type: "",
        type_name: "",
        onSiteDate: "",
        onSiteTime: "",
        remark: "",
      },
      showType: false,
      showData: false,
      showTime: false,
      currentTime: "",
      actions: [{ name: "选项一" }, { name: "选项二" }, { name: "选项三" }],
    };
  },

  created() {
    this.submitData.order_info_id = this.$route.query.id;
    let hh = new Date().getHours();
    let mf =
      new Date().getMinutes() < 10
        ? "0" + new Date().getMinutes()
        : new Date().getMinutes();
    this.submitData.order_info_id = this.$route.query.id;
    this.submitData.onSiteDate = new Date().getFullYear() + "-" + ( new Date().getMonth() >= 9 ? (new Date().getMonth() + 1) : '0'+ (new Date().getMonth() + 1) ) + "-" + new Date().getDate();
    this.submitData.onSiteTime = hh + ":" + mf + ":00";
    //上门预约-类型
    this.reservationOnSiteAdd();
  },

  methods: {
    // 上门预约-类型
    reservationOnSiteAdd() {
      var that = this;
      that.$api
        .reservationOnSiteAddAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            if (res.data.data.typeList.length > 0) {
              res.data.data.typeList.forEach((element) => {
                element.name = element.itemText;
              });
            }
            that.submitData.type = res.data.data.typeList[0].itemId;
            that.submitData.type_name = res.data.data.typeList[0].itemText;
            that.actions = res.data.data.typeList;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //选择类型
    onSelect(item) {
      this.show = false;
      this.submitData.type = item.itemId;
      this.submitData.type_name = item.itemText;
    },

    //日期格式化
    formatDate(date) {
      return `${date.getFullYear()}-${ date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' +( date.getMonth() + 1)}-${date.getDate()}`;
    }, 

    //选择上门日期
    onConfirmData(date) {
      this.showData = false;
      this.submitData.onSiteDate = this.formatDate(date);
    },

    onConfirmTime(date) {
      this.showTime = false;
      console.log(date);
      this.submitData.onSiteTime = date + ":00";
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onSubmit() {
      var that = this;

      that.submitData.onSiteDate = that.submitData.onSiteDate.toString();
      that.submitData.onSiteTime = that.submitData.onSiteTime.toString();
      let dd = that.submitData.onSiteDate.substring(8);
      if(dd.length < 2){
        dd = '0'+dd;
      }
      that.submitData.onSiteDate = that.submitData.onSiteDate.substring(0,7)+'-'+dd

      console.log(typeof that.submitData.onSiteDate )
      // that.$delete(that.submitData,'type_name')
      that.$api
        .reservationOnSiteSaveAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$router.push({ path: "/order/contractFinish" });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.appointment_data {
  // 预约时间
  .data_time {
    display: flex;
    flex-direction: column;

    .time_list {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin: 0px 20px;
      padding: 15px 0px;
      font-size: 14px;
      align-items: center;

      .list_input {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        font-size: 13px;
        padding: 10px;
        display: flex;
        align-items: center;

        input {
          border: none;
          width: 160px;
          padding: 0px 7px;
        }
      }
    }
  }

  .data_title {
    font-size: 14px;
    color: #666;
    padding: 15px 20px;
  }

  /deep/ .van-field__value {
    background: #f4f3f8;
    padding: 10px;
    height: 130px;
  }

  // 表单
  .van-button {
    width: 350px;
    margin: auto;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/order/appointmentData.vue